



























































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import RetensiStore from "@/store/modules/RetensiAlihMediaStore";
import { RetensiSession, RetensiChecklistItem } from "@/types/RetensiAlihMedia";

interface LocalRow {
  root_cause: string;
  rekomendasi_tindak_lanjut: string;
  penanggung_jawab_text: string;
  tenggat_waktu: string;
}

@Component({ name: "RetensiStepTemuan" })
export default class StepTemuan extends Vue {
  @Prop({ type: Object, default: null }) session!: RetensiSession | null;

  store = RetensiStore;
  saving = false;
  dirtyKodes = new Set<string>();
  catatanDirty = false;
  catatanUmum = "";
  local: Record<string, LocalRow> = {};

  get temuan(): RetensiChecklistItem[] {
    return this.store.temuanKritis;
  }

  @Watch("session", { immediate: true, deep: true })
  onSessionChange(s: RetensiSession | null) {
    if (!s) return;
    this.catatanUmum = s.catatan_umum_auditor ?? "";
    this.catatanDirty = false;
    for (const it of this.temuan) {
      this.local[it.kode_item] = {
        root_cause: it.root_cause ?? "",
        rekomendasi_tindak_lanjut: it.rekomendasi_tindak_lanjut ?? "",
        penanggung_jawab_text: it.penanggung_jawab_text ?? "",
        tenggat_waktu: it.tenggat_waktu ?? "",
      };
    }
    this.dirtyKodes.clear();
  }

  markDirty(kode: string) {
    this.dirtyKodes.add(kode);
    this.dirtyKodes = new Set(this.dirtyKodes);
  }

  async saveAll() {
    if (!this.session?.id) return;
    this.saving = true;
    try {
      if (this.dirtyKodes.size > 0) {
        const items = Array.from(this.dirtyKodes).map((kode) => ({
          kode_item: kode,
          ...this.local[kode],
        }));
        await this.store.bulkSaveChecklist({
          sessionId: this.session.id,
          items,
        });
      }
      if (this.catatanDirty) {
        await this.store.updateSession({
          id: this.session.id,
          data: { catatan_umum_auditor: this.catatanUmum },
        });
      }
      this.dirtyKodes.clear();
      this.dirtyKodes = new Set();
      this.catatanDirty = false;
      this.$emit("refresh");
    } finally {
      this.saving = false;
    }
  }
}
